module.exports = __webpack_public_path__ + "static/preview-gotland-6b81468a5a52df961b376cf1d26c95c6.jpg";